import { useState } from "react";
import Motion from "../../../Componentes/Motion";
import Tablas from "../../../Componentes/Tablas";
import { useProveedores } from "./ProveedoresProvider";
import {
  Fab,
  Icon,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core";
import { StylesGenerales } from "../../../Styles/StylesGenerales";

const ProveedoresLista = () => {
  const [inputSearch, setInputSearch] = useState("");
  const { lista, cargando, setFormulario, setOpenDialog, borrarRegistro } =
    useProveedores();
  const classes = StylesGenerales();

  const Acciones = ({ id, extraprops }) => (
    <div className={classes.botones}>
      <Fab
        variant="round"
        color="primary"
        size="small"
        onClick={() => {
          let i = lista.findIndex((e) => e.id_proveedor === id);
          setFormulario(lista[i]);
          setOpenDialog(true);
        }}
      >
        <Icon>edit</Icon>
      </Fab>
      <Fab
        variant="round"
        color="secondary"
        size="small"
        onClick={() => {
          borrarRegistro(id, extraprops);
        }}
      >
        <Icon>delete</Icon>
      </Fab>
    </div>
  );

  const FilterData = lista.filter((item) =>
    item.nombre_proveedor.toLowerCase().includes(inputSearch.toLowerCase())
  );
  const columns = [
    {
      field: "id_proveedor",
      headerName: "ID",
    },
    {
      field: "ruc_proveedor",
      headerName: "Documento",
    },
    {
      field: "nombre_proveedor",
      headerName: "Nombre",
    },
    {
      field: "telefono_proveedor",
      headerName: "Contacto",
    },
  ];
  const search = (
    <div className={classes.inputs}>
      <TextField
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <Icon>search</Icon>
              </IconButton>
            </InputAdornment>
          ),
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
          }
        }}
        onChange={(e) => {
          setInputSearch(e.target.value);
        }}
        variant="outlined"
        label="Buscar"
        value={inputSearch}
      />
      <Tooltip title="AGREGAR NUEVO" arrow>
        <Button
          color="primary"
          variant="outlined"
          size="large"
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          AGREGAR
        </Button>
      </Tooltip>
    </div>
  );
  return (
    <Motion>
      <Tablas
        nombretabla="Proveedores"
        icono="local_shipping"
        bgicono="#3f51b5"
        namecolumnID={`id_proveedor`}
        columnas={columns}
        filas={FilterData}
        Acciones={Acciones}
        extraprops={"nombre_proveedor"}
        search={search}
        cargando={cargando}
      />
      <div className={classes.page}></div>
    </Motion>
  );
};

export default ProveedoresLista;
